// oxlint-disable-next-line no-restricted-imports
import { fromJS, Record } from '@gonfalon/immutable-shim/immutableShim';
import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';
import { v4 } from 'uuid';

export class Prerequisite extends Record<{
  _key?: string;
  // This will always exist for prereqs coming from the server, but will not for prerequisites that were
  // just added via the UI -- should we rely on the empty-string default or undefined?
  key: string;
  variation: number;
  variationId: string; // What is this?
}>({
  _key: undefined,
  key: '',
  variation: 0,
  variationId: '',
}) {
  toRep() {
    return fromJS(this.toJSON()).withMutations((map: Prerequisite) => {
      map.remove('_key');
    });
  }
}

export function createPrerequisite(props: CreateFunctionInput<Prerequisite> = {}) {
  const p = props instanceof Prerequisite ? props : new Prerequisite(fromJS(props));
  return p.update('_key', (key) => key || v4());
}
